import { Component } from '@angular/core';

@Component({
    selector: 'app-four-o-one',
    templateUrl: './four-o-one.component.html',
    styleUrls: ['./four-o-one.component.scss'],
    standalone: false
})
export class FourOOneComponent {
  goBack(): void { history.back(); }
}
